import { ComponentType } from '@angular/cdk/overlay';
import { InjectionToken } from '@angular/core';

export const GalleryPreviewComponentInjector = new InjectionToken<ComponentType<object>>(
  'RxGalleryPreviewComponent',
);
